<template>
  <v-checkbox
    v-model="value.value"
    :label="value == null ? '' : value.caption"
    :name="value == null ? '' : value.name"
    :readonly="value == null ? false : value.readonly"
    :required="value == null ? false : value.required"
    :rules="rules"
  />
</template>

<script>
export default {
  name: "MyFormCheckbox",
  props: {
    value: {
      type: Object,
      default: function() {
        return { name: "MyFormInputNotSet", value: false, caption: "not set" };
      },
    },
  },
  computed: {
    rules() {
      const rules = [];

      if (this.value.required) {
        const rule = (v) => !!v || this.$i18n.t("common.required");

        rules.push(rule);
      }
      return rules;
    },
  },
};
</script>

<style scoped></style>
